import React from "react";
import { Typography } from "@material-ui/core";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Centered = styled.div`
  margin: auto;
  text-align: center;
`;

export interface IErrorProps {
  msg: string;
}

const ErrorComponent = (props: IErrorProps) => (
  <Container>
    <Centered>
      <SentimentDissatisfiedIcon fontSize="large" />
      <Typography variant="h4" component="h4">
        {props.msg}
      </Typography>
    </Centered>
  </Container>
);

export default ErrorComponent;
